import { useEffect, useState } from 'react';

import { getUserPerson } from '../services/individualBioService';
import { UserPerson } from '../types';

export const useUserDetails = (userPersonUuid?: string | null) => {
  const [userDetails, setUserDetails] = useState<UserPerson | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!userPersonUuid) return;
    setLoading(true);
    getUserPerson(userPersonUuid)
      .then(setUserDetails)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [userPersonUuid]);

  return { userDetails, loading, error };
};
